import { useEffect, useState } from "react";
import { FormDebitsNegotiation } from "../form/FormNegotiationDebits";
import { getRenterPayments } from "@/common/services/payments.api";
import { PaymentInfo } from "@/types/payment.type";
import { IRenter } from "@/types/renter.type";
import { getRenterById } from "@/common/services/renters.api";
type Props = {
  renterId: string;
}
export function DebitNegotiationDashboard({ renterId }: Props) {
  const [payments, setPayments] = useState<PaymentInfo[]>([]);
  const [renterData, setRenterData] = useState<IRenter | null>(null);

  useEffect(() => {
    async function fetchRenter(renterId: string) {
      const result = await getRenterById(renterId);
      if (result.ok) {
        setRenterData(result.data as IRenter);
      }
    }
    fetchRenter(renterId);
  }, [renterId])

  useEffect(() => {
    async function fetchPayments(renterId: string) {
      if (!renterId) {
        throw new Error("Renter ID is required");
      }

      const result = await getRenterPayments(renterId);

      if (result.ok) {
        setPayments(result.data || []);
      }
    }

    fetchPayments(renterId);
  }, [renterId])
  return (
    renterData ? (
      <FormDebitsNegotiation
        renter={renterData}
        payments={payments}
      />
    ) : <div>Carregando dados do locatário...</div>
  )
}